.pes-software-modal-row {
  font-size: 12px;
  line-height: 1.25;
  padding-bottom: 3px;
}

:host(:not([dir="rtl"])) .pes-software-modal-row {
  padding-left: 34px;
}

:host([dir="rtl"]) .pes-software-modal-row {
  padding-right: 34px;
}

@media screen and (min-width: 980px) {
  .pes-software-modal-row {
    display: grid;
    grid-template-columns: 3fr 2fr 1fr 1fr 1fr 1fr 0.5fr 0.5fr;
    padding-bottom: 0;
  }

  :host(:not([dir="rtl"])) .pes-software-modal-row {
    padding-left: 17px;
  }

  :host([dir="rtl"]) .pes-software-modal-row {
    padding-right: 17px;
  }
}

.pes-software-modal-row__cell {
  display: block;
  margin-bottom: 10px;
  box-sizing: border-box;
}

@media screen and (min-width: 980px) {
  .pes-software-modal-row__cell {
    margin-bottom: 0;
  }
}

.pes-software-modal-row__cell--versions {
  margin-bottom: 11px;
}

@media screen and (min-width: 980px) {
  .pes-software-modal-row__cell--versions {
    margin: 0;
  }
}

@media screen and (max-width: 719px) {
  .pes-software-modal-row__cell--format, .pes-software-modal-row__cell--size, .pes-software-modal-row__cell--date {
    display: inline-block;
  }

  :host(:not([dir="rtl"])) .pes-software-modal-row__cell--format, :host(:not([dir="rtl"])) .pes-software-modal-row__cell--size, :host(:not([dir="rtl"])) .pes-software-modal-row__cell--date {
    margin-right: 15px;
  }

  :host([dir="rtl"]) .pes-software-modal-row__cell--format, :host([dir="rtl"]) .pes-software-modal-row__cell--size, :host([dir="rtl"]) .pes-software-modal-row__cell--date {
    margin-left: 15px;
  }
}

.pes-software-modal-row__icon {
  position: absolute;
  top: -3px;
}

:host(:not([dir="rtl"])) .pes-software-modal-row__icon {
  left: -26px;
}

:host([dir="rtl"]) .pes-software-modal-row__icon {
  right: -26px;
}

.pes-software-modal-row__link {
  text-decoration: none;
  outline: none;
  position: relative;
  color: inherit;
}

.pes-software-modal-row__link:hover {
  text-decoration: underline;
}

.pes-software-modal-row__download-link {
  background: none;
  color: #42b4e6;
  border: none;
  padding: 0;
  cursor: pointer;
  outline: inherit;
  font-family: inherit;
  display: flex;
  align-items: center;
  text-decoration: none;
}

:host(:not([dir="rtl"])) .pes-software-modal-row__download-link {
  padding-left: 0;
}

:host([dir="rtl"]) .pes-software-modal-row__download-link {
  padding-right: 0;
}

.pes-software-modal-row__download-link:hover {
  text-decoration: underline;
}

.pes-software-modal-row__download-link:hover {
  text-decoration: none;
}

:host(:not([dir="rtl"])) .pes-software-modal-row__download-text {
  margin-left: 5px;
}

:host([dir="rtl"]) .pes-software-modal-row__download-text {
  margin-right: 5px;
}

.pes-software-modal-row__download-text:hover {
  text-decoration: underline;
}

.pes-software-modal-row__label {
  font-weight: bold;
}

:host(:not([dir="rtl"])) .pes-software-modal-row__label {
  float: left;
  margin-right: 3px;
}

:host([dir="rtl"]) .pes-software-modal-row__label {
  float: right;
  margin-left: 3px;
}

@media screen and (min-width: 980px) {
  .pes-software-modal-row__label {
    display: none;
  }
}